"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const Video = createSVGIcon(
  <>
    <rect
      x="0.5"
      y="0.5"
      width="17"
      height="17"
      rx="0.5"
      stroke="currentColor"
    />
    <path
      d="M18.178 9.3233C18.0919 9.26365 18.0919 9.13635 18.178 9.0767L23.7646 5.20618C23.8641 5.13726 24 5.20846 24 5.32948L24 13.0705C24 13.1915 23.8641 13.2627 23.7646 13.1938L18.178 9.3233Z"
      stroke="currentColor"
    />
  </>,
  "Video",
  {
    viewBox: "0 0 26 18",
    titleAccess: "Video",
    fill: "none",
  }
);
